module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-3.898e75c6.svg";